import axios from 'axios';
import Cookies from 'js-cookie';
import getRandomArtistUrl from '../utils/getRandomArtistUrl';
import { appConfig } from '../constants';

async function sendRandomArtistRequest(setLoading) {
  let artist = { followers: { total: 0 } };
  while (artist.followers.total < appConfig.minFollowers) {
    let items = [];
    for (let i = 0; i < appConfig.pool; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      const res = await axios.get(getRandomArtistUrl(i));
      items = items.concat(res.data.artists.items);
    }
    const valid = items.filter((item) => item.followers.total >= appConfig.minFollowers);
    if (valid.length > 0) artist = valid[Math.floor(Math.random() * valid.length)];
  }
  setLoading(false);
  return artist;
}

async function getRelatedArtistsRequest(id) {
  const res = await axios.get(`https://api.spotify.com/v1/artists/${id}/related-artists`);
  return res.data.artists;
}

axios.interceptors.request.use(
  (config) => {
    const newConfig = config;
    if (config?.headers) {
      newConfig.headers.Authorization = `Bearer ${Cookies.get('spotifyAuthToken')}`;
    }
    return newConfig;
  },
  (error) => {
    Promise.reject(error);
  },
);

const api = {
  sendRandomArtistRequest,
  getRelatedArtistsRequest,
};

export default api;
